const getSites = (rootState) => rootState.sites.data;

export default getSites;
